"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Root = exports.Arrow = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.primary.main,
  color: theme.palette.text.primary,
  cursor: 'pointer',
  display: 'flex',
  fontSize: '1.2rem',
  gap: theme.spacing(1),
  justifyContent: 'center',
  padding: theme.spacing(2, 0),
  position: 'relative'
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)({
  lineHeight: '1.8rem'
});
const Arrow = exports.Arrow = (0, _mui.styled)(_icons.ArrowRightThin, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['arrowAlwaysCentered'])
})(({
  arrowAlwaysCentered,
  theme
}) => ({
  fontSize: '1.6rem',
  [theme.breakpoints.up('sm')]: {
    ...(arrowAlwaysCentered ? null : {
      position: 'absolute',
      right: theme.spacing(3)
    })
  }
}));
//# sourceMappingURL=styles.js.map